import { equals } from 'ramda';

const getExtraInvalMessageInfo = (message, customerCSPCategory) => {
  if (equals(customerCSPCategory, 'Profession médicale et paramédicale et règlementée')) {
    return `Invalidité partielle
    Si vous vous retrouvez en situation d’invalidité partielle, une rente trimestrielle vous est versée pour couvrir votre perte de revenus.
    Votre invalidité est considérée partielle lorsque le taux d’invalidité est compris entre 20% et 66%.

    Invalidité totale
    Si vous vous retrouvez en situation d’invalidité total, une rente trimestrielle vous est versée pour couvrir votre perte de revenus.
    Votre invalidité est considérée totale lorsque le taux d’invalidité est supérieur à 66%.

    Taux invalidité
    Le taux d’invalidité est déterminé sur la base du taux d’invalidité professionnelle, défini à la suite d’une expertise réalisée par un médecin expert indépendant.`;
  }
  return message;
};

export default getExtraInvalMessageInfo;
